import Vue from 'vue';

// General/Utilities Apps
Vue.component('skip-links', () =>
  import(
    /* webpackChunkName: "skip-links" */
    '@components/SkipLinks.vue'
  )
);
Vue.component('support-bar', () =>
  import(
    /* webpackChunkName: "support-bar" */
    '@components/SupportBar.vue'
  )
);

Vue.component('navigation-app', () =>
  import(
    /* webpackChunkName: "navigation-app" */
    '@components/NavigationApp.vue'
  )
);

Vue.component('widget-url-generator', () =>
  import(
    /* webpackChunkName: "widget-url-generator" */
    '@components/WidgetUrlGenerator/App.vue'
  )
);

Vue.component('navigator', () =>
  import(
    /* webpackChunkName: "navigation-app" */
    '@components/Navigator/App.vue'
  )
);

Vue.component('accessible-map', () =>
  import(
    /* webpackChunkName: "accessible-map" */
    '@components/AccessibleMap/App.vue'
  )
);

Vue.component('event-search', () =>
  import(
    /* webpackChunkName: "event-search-app" */
    '@components/EventSearch/App.vue'
  )
);

Vue.component('accessible-navigator', () =>
  import(
    /* webpackChunkName: "accessible-navigator-app" */
    '@components/AccessibleNavigator/App.vue'
  )
);

Vue.component('accessible-navigator-item', () =>
  import(
    /* webpackChunkName: "accessible-navigator-item" */
    '@components/AccessibleNavigator/Item.vue'
  )
);

Vue.component('accessible-navigator-catalog', () =>
  import(
    /* webpackChunkName: "accessible-navigator-catalog" */
    '@components/AccessibleNavigator/Catalog.vue'
  )
);

Vue.component('filter-app', () =>
  import(
    /* webpackChunkName: "filter-app" */
    '@components/FilterApp.vue'
  )
);
Vue.component('opening-times-app', () =>
  import(
    /* webpackChunkName: "opening-times-app" */
    '@components/OpeningTimesApp.vue'
  )
);
Vue.component('show-opening-times-app', () =>
  import(
    /* webpackChunkName: "show-opening-times-app" */
    '@components/ShowOpeningTimesApp.vue'
  )
);
Vue.component('show-opening-times-summary', () =>
  import(
    /* webpackChunkName: "show-opening-times-app" */
    '@components/ShowOpeningTimesSummary.vue'
  )
);
Vue.component('opening-time', () =>
  import(
    /* webpackChunkName: "opening-time" */
    '@components/OpeningTime.vue'
  )
);
Vue.component('accordion', () =>
  import(
    /* webpackChunkName: "accordion" */
    '@components/Accordion.vue'
  )
);
Vue.component('teaser', () =>
  import(
    /* webpackChunkName: "teaser" */
    '@components/Teaser.vue'
  )
);
Vue.component('notification-app', () =>
  import(
    /* webpackChunkName: "notification-app" */
    '@components/NotificationApp.vue'
  )
);
Vue.component('toast-app', () =>
  import(
    /* webpackChunkName: "toast-app" */
    '@components/ToastApp.vue'
  )
);
Vue.component('user-bookings', () =>
  import(
    /* webpackChunkName: "user-bookings" */
    '@components/UserBookings.vue'
  )
);
Vue.component('user-bookings-item', () =>
  import(
    /* webpackChunkName: "user-bookings-item" */
    '@components/UserBookingsItem.vue'
  )
);
Vue.component('product-comparison', () =>
  import(
    /* webpackChunkName: "product-comparison" */
    '@components/ProductComparison.vue'
  )
);
Vue.component('autocomplete-app', () =>
  import(
    /* webpackChunkName: "autocomplete-app" */
    '@components/AutocompleteApp.vue'
  )
);
Vue.component('slider-app', () =>
  import(
    /* webpackChunkName: "slider-app" */
    '@components/SliderApp.vue'
  )
);
Vue.component('slider-app-schwarzes-brett', () =>
  import(
    /* webpackChunkName: "slider-app-schwarzes-brett" */
    '@components/SliderAppSchwarzesBrett.vue'
  )
);

Vue.component('bread-crumbs-app', () =>
  import(
    /* webpackChunkName: "bread-crumbs-app" */
    '@components/BreadCrumbs'
  )
);

Vue.component('vue-trix', require('vue-trix').default);
Vue.component('static-map', () =>
  import(
    /* webpackChunkName: "static-map" */
    '@components/StaticMap.vue'
  )
);
Vue.component('static-map-with-address', () =>
  import(
    /* webpackChunkName: "static-map-with-address" */
    '@components/StaticMapWithAddress.vue'
  )
);
Vue.component('modal-app', () =>
  import(
    /* webpackChunkName: "modal-app" */
    '@components/ModalApp.vue'
  )
);
Vue.component('geo-search', () =>
  import(
    /* webpackChunkName: "geo-search" */
    '@components/GeoSearch.vue'
  )
);
Vue.component('form-data', () =>
  import(
    /* webpackChunkName: "form-data" */
    '@components/FormData.vue'
  )
);
Vue.component('v-button', () =>
  import(
    /* webpackChunkName: "v-button" */
    '@components/Button.vue'
  )
);
Vue.component('tag', () =>
  import(
    /* webpackChunkName: "tag" */
    '@components/Tag.vue'
  )
);
Vue.component('keyword', () =>
  import(
    /* webpackChunkName: "keyword" */
    '@components/Keyword.vue'
  )
);
Vue.component('show-all-dates-button', () =>
  import(
    /* webpackChunkName: "show-all-dates-button" */
    '@components/ShowAllDatesButton.vue'
  )
);
Vue.component('show-all-dates', () =>
  import(
    /* webpackChunkName: "show-all-dates" */
    '@components/ShowAllDates.vue'
  )
);
Vue.component('form-error', () =>
  import(
    /* webpackChunkName: "form-error" */
    '@components/FormError.vue'
  )
);
Vue.component('form-label', () =>
  import(
    /* webpackChunkName: "form-label" */
    '@components/FormLabel.vue'
  )
);

Vue.component('media-upload', () =>
  import(
    /* webpackChunkName: "media-upload" */
    '@components/MediaUpload/MediaUpload.vue'
  )
);
Vue.component('media-file', () =>
  import(
    /* webpackChunkName: "media-file" */
    '@components/MediaUpload/MediaFile.vue'
  )
);
Vue.component('file-upload', () =>
  import(
    /* webpackChunkName: "file-upload" */
    '@components/FileUpload.vue'
  )
);
Vue.component('gallery-upload', () =>
  import(
    /* webpackChunkName: "gallery-upload" */
    '@components/GalleryUpload.vue'
  )
);
Vue.component('galleries-upload', () =>
  import(
    /* webpackChunkName: "galleries-upload" */
    '@components/GalleriesUpload.vue'
  )
);
Vue.component('category-selection-app', () =>
  import(
    /* webpackChunkName: "category-selection-app" */
    '@components/CategorySelectionApp'
  )
);

Vue.component('multiselect', () =>
  import(
    /* webpackChunkName: "multiselect" */
    '@components/Multiselect/Multiselect.vue'
  )
);

Vue.component('lightbox', () =>
  import(
    /* webpackChunkName: "lightbox" */
    '@components/Lightbox/Lightbox.vue'
  )
);

Vue.component('loading-bar', () =>
  import(
    /* webpackChunkName: "loading-bar" */
    '@components/LoadingBar.vue'
  )
);

Vue.component('institution-results', () =>
  import(
    /* webpackChunkName: "institution-results" */
    '@components/Institution/InstitutionResults.vue'
  )
);
Vue.component('institution-teaser', () =>
  import(
    /* webpackChunkName: "institution-teaser" */
    '@components/Institution/InstitutionTeaser.vue'
  )
);
Vue.component('institution-edit', () =>
  import(
    /* webpackChunkName: "institution-edit" */
    '@components/Institution/Edit.vue'
  )
);
Vue.component('institution-form', () =>
  import(
    /* webpackChunkName: "institution-form" */
    '@components/Institution/Form.vue'
  )
);
Vue.component('institution-preview', () =>
  import(
    /* webpackChunkName: "institution-preview" */
    '@components/Institution/Preview.vue'
  )
);
Vue.component('institution-events', () =>
  import(
    /* webpackChunkName: "institution-events" */
    '@components/Institution/Events.vue'
  )
);
Vue.component('a11y-bar', () =>
  import(
    /* webpackChunkName: "a11y-bar" */
    '@components/Institution/A11yBar.vue'
  )
);
Vue.component('a11y-infos', () =>
  import(
    /* webpackChunkName: "a11y-infos" */
    '@components/Institution/A11yInfos.vue'
  )
);

Vue.component('institution-form-upgrade', () =>
  import(
    /* webpackChunkName: "institution-form-upgrade" */
    '@components/Institution/Form/Upgrade.vue'
  )
);
Vue.component('institution-upgrade-app', () =>
  import(
    /* webpackChunkName: "institution-upgrade-app" */
    '@components/Institution/Upgrade/App.vue'
  )
);

Vue.component('services-list', () =>
  import(
    /* webpackChunkName: "services-list" */
    '@components/ServicesList.vue'
  )
);

Vue.component('socialmedia-form', () =>
  import(
    /* webpackChunkName: "socialmedia-form" */
    '@components/SocialmediaForm.vue'
  )
);

Vue.component('socialmedia-list', () =>
  import(
    /* webpackChunkName: "socialmedia-list" */
    '@components/SocialmediaList.vue'
  )
);

Vue.component('payments-list', () =>
  import(
    /* webpackChunkName: "payments-list" */
    '@components/PaymentMethodsList.vue'
  )
);

Vue.component('password-input', () =>
  import(
    /* webpackChunkName: "password-input" */
    '@components/PasswordInput.vue'
  )
);

//
// Event Related Apps
Vue.component('dates-picker', () =>
  import(
    /* webpackChunkName: "dates-picker" */
    '@components/EventDatesPicker/DatesPicker.vue'
  )
);
Vue.component('times-picker', () =>
  import(
    /* webpackChunkName: "times-picker" */
    '@components/EventDatesPicker/TimesPicker.vue'
  )
);
Vue.component('event-dates-picker', () =>
  import(
    /* webpackChunkName: "event-dates-picker" */
    '@components/EventDatesPicker/EventDatesPicker.vue'
  )
);
Vue.component('event-edit-app', () =>
  import(
    /* webpackChunkName: "event-edit-app" */
    '@components/EventComponents/Edit.vue'
  )
);
Vue.component('event-form-app', () =>
  import(
    /* webpackChunkName: "event-form-app" */
    '@components/EventComponents/Form.vue'
  )
);
Vue.component('event-preview-app', () =>
  import(
    /* webpackChunkName: "event-preview-app" */
    '@components/EventComponents/Preview.vue'
  )
);
Vue.component('event-dates', () =>
  import(
    /* webpackChunkName: "event-dates" */
    '@components/EventComponents/EventDates.vue'
  )
);

Vue.component('event-results', () =>
  import(
    /* webpackChunkName: "event-results" */
    '@components/EventComponents/EventResults.vue'
  )
);
Vue.component('event-teaser', () =>
  import(
    /* webpackChunkName: "event-teaser" */
    '@components/EventComponents/EventTeaser.vue'
  )
);
Vue.component('advertisement-results', () =>
  import(
    /* webpackChunkName: "advertisement-results" */
    '@components/AdvertisementComponents/AdvertisementResults.vue'
  )
);
Vue.component('advertisement-teaser', () =>
  import(
    /* webpackChunkName: "advertisement-teaser" */
    '@components/AdvertisementComponents/AdvertisementTeaser.vue'
  )
);

//
// Business Listing Related Apps
Vue.component('booking-business-listing', () =>
  import(
    /* webpackChunkName: "booking-business-listing" */
    '@components/BookingBusinessListing/BookingBusinessListingApp.vue'
  )
);
Vue.component('institution-pricing', () =>
  import(
    /* webpackChunkName: "institution-pricing" */
    '@components/BookingBusinessListing/Pricing.vue'
  )
);

// Booking Advertisment
Vue.component('booking-advertisment', () =>
  import(
    /* webpackChunkName: "booking-advertisment" */
    '@components/BookingAdvertisement/BookingAdvertisementApp.vue'
  )
);

// Advertisement Related Apps
Vue.component('advertisement-edit-app', () =>
  import(
    /* webpackChunkName: "advertisement-edit-app" */
    '@components/AdvertisementComponents/Edit.vue'
  )
);
Vue.component('advertisement-form-app', () =>
  import(
    /* webpackChunkName: "advertisement-form-app" */
    '@components/AdvertisementComponents/Form.vue'
  )
);
Vue.component('advertisement-preview-app', () =>
  import(
    /* webpackChunkName: "advertisement-preview-app" */
    '@components/AdvertisementComponents/Preview.vue'
  )
);

// Address Related Apps
Vue.component('address-and-contact-app', () =>
  import(
    /* webpackChunkName: "address-and-contact-app" */
    '@components/AddressAndContact/App.vue'
  )
);
Vue.component('address-and-contact-item', () =>
  import(
    /* webpackChunkName: "address-and-contact-item" */
    '@components/AddressAndContact/Item.vue'
  )
);
Vue.component('address-and-contact-form', () =>
  import(
    /* webpackChunkName: "address-and-contact-form" */
    '@components/AddressAndContact/Form.vue'
  )
);

//
// concept apps (to be removed)
Vue.component('concept-institution-app', () =>
  import(
    /* webpackChunkName: "concept-institution-app" */
    '../../concept/ConceptInstitutionApp.vue'
  )
);
Vue.component('concept-event-app', () =>
  import(
    /* webpackChunkName: "concept-event-app" */
    '../../concept/ConceptEventApp.vue'
  )
);
Vue.component(
  'concept-business-listing-booking-app',

  () =>
    import(
      /* webpackChunkName: "navigation-app" */
      '../../concept/ConceptBusinessLisingBookingApp.vue'
    )
);
Vue.component('concept-commercial-ad-booking-app', () =>
  import(
    /* webpackChunkName: "concept-commercial-ad-booking-app" */
    '../../concept/ConceptCommercialAdBookingApp.vue'
  )
);
Vue.component('pharmacyemergencyservice-app', () =>
  import(
    /* webpackChunkName: "pharmacyemergencyservice-app" */
    '@components/PharmacyEmergencyService/PharmacyEmergencyService.vue'
  )
);
Vue.component('pharmacy-area', () =>
  import(
    /* webpackChunkName: "pharmacyemergencyservice-app" */
    '@components/PharmacyEmergencyService/Area.vue'
  )
);
